import { Link } from "@/lib/router-compat";
import { useTranslation } from "react-i18next";
import { useLanguageRouting } from "@/hooks/useLanguageRouting";

const Footer = () => {
  const { t } = useTranslation('common');
  const { getLocalizedLink } = useLanguageRouting();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muted/30 border-t border-border/60">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold tracking-tight text-foreground mb-3">
              Nearshore.Africa
            </h3>
            <p className="text-sm text-muted-foreground max-w-md leading-relaxed">
              Your trusted guide to outsourcing software development in Africa. Connecting businesses with top-tier African tech talent.
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4 font-medium">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to={getLocalizedLink("/")} className="text-foreground/70 hover:text-foreground transition-colors">
                  {t('breadcrumbs.home')}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedLink("/what-is-nearshoring")} className="text-foreground/70 hover:text-foreground transition-colors">
                  {t('nav.whatIsNearshoring')}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedLink("/nearshoring-vs-offshoring-vs-outsourcing")} className="text-foreground/70 hover:text-foreground transition-colors">
                  {t('nav.nearshoringVsOffshoring')}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedLink("/companies")} className="text-foreground/70 hover:text-foreground transition-colors">
                  {t('nav.companies')}
                </Link>
              </li>
              <li>
                <Link to={getLocalizedLink("/blog")} className="text-foreground/70 hover:text-foreground transition-colors">
                  {t('nav.blog')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-4 font-medium">
              {t('footer.featuredPartner')}
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href="https://evolvice.de/en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground/70 hover:text-foreground transition-colors"
                  aria-label="Visit Evolvice GmbH website (opens in new tab)"
                >
                  Evolvice
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-border/60">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-muted-foreground text-center md:text-left">
              {t('footer.copyright', { year: currentYear })}
            </p>
            <div className="flex gap-6">
              <Link
                to={getLocalizedLink("/privacy-policy")}
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {t('footer.privacy')}
              </Link>
              <Link
                to={getLocalizedLink("/imprint")}
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {t('footer.imprint')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
